import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FaIconSharedComponent } from './fa.icon.component';

@NgModule({
    declarations: [
        FaIconSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        FaIconSharedComponent
    ]
})

export class FaIconSharedModule {}
